import { hDeepCopy } from '@/utils/helpers';
import ShButton from '@/components/Helpers/ShButton';
import DepartmentSign from '@/components/Common/DepartmentSign';

// @vue/component
export default {
  name: 'DepartmentNameAndSymbolForm',

  components: {
    ShButton,
    DepartmentSign,
  },

  props: {
    department: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      isAnEditingForm: !!this.department,
      possibleIcons: ['fa-address-book-o', 'fa-archive', 'fa-university', 'fa-at', 'fa-briefcase',
        'fa-camera', 'fa-cart-arrow-down', 'fa-cloud', 'fa-cogs', 'fa-comments-o', 'fa-diamond',
        'fa-envelope-open', 'fa-fax', 'fa-gamepad', 'fa-globe', 'fa-handshake-o', 'fa-info-circle',
        'fa-wrench',
      ],
      editableDepartment: this.department ? hDeepCopy(this.department) : {
        name: null,
        icon: 'fa-question-circle-o',
        color: '#bdbdbd',
      },
    };
  },

  computed: {
    isLoading() {
      return this.$store.getters['app/pendingStoreActions'].includes([
        'departments/update',
      ]);
    },
  },

  watch: {
    editableDepartment: {
      handler(value) {
        this.$emit('update', value);
      },
      deep: true,
    },
  },

  methods: {
    handleChangeColor(color) {
      this.editableDepartment.color = color;
    },
    async handleSaveEditDepartment() {
      await this.$store.dispatch('departments/update', this.editableDepartment);
      this.$store.dispatch('departments/getList');
      this.$emit('closeModal');
    },
    handleCancelEditDepartment() {
      this.$emit('closeModal');
    },
  },
};
